import React from 'react';
import PropTypes from "prop-types";
import { TableCell, TableHead, TableRow, TableSortLabel, Checkbox } from '@material-ui/core';

export const TableHeadGeneracion = (props) => {

    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    const headCells = [
      { id: "agregado", numeric: false, disablePadding: true, label: "" },
      { id: "apellidoNombre", numeric: false, disablePadding: true, label: "Apellido y Nombre", },
      // { id: "expand" },
      { id: "cuil", numeric: true, disablePadding: false, label: "CUIL" },
      { id: "descripcionAfiliacion", numeric: true, disablePadding: false, label: "Tipo Afiliación" },
      { id: "empresa", numeric: false, disablePadding: false, label: "Empresa" },
      { id: "cuitEmpresa", numeric: true, disablePadding: false, label: "CUIT" },
      { id: "periodo", numeric: true, disablePadding: false, label: "Periodo" },
      { id: "cuota", numeric: true, disablePadding: false, label: "Importe ($)" },
      { id: "reImputacion", numeric: true, disablePadding: false, label: "ReImputación ($)" },
      { id: "deudaAnt", numeric: true, disablePadding: false, label: "Saldo ($)" },
      // { id: "total", numeric: true, disablePadding: false, label: "Total ($)" },
      {}
    ];
  
    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ "aria-label": "seleccionar todos los afiliados" }}
            />
          </TableCell>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={"left"}  /* {headCell.numeric ? "right" : "left"} */
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  
  TableHeadGeneracion.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };